(function ($, Global) {
	var FormContactComponent = function (model) {
		this.model = model;
	}

	FormContactComponent.prototype.initEvents = function () {
		this.publishers();
	}

	FormContactComponent.prototype.publishers = function () {
		var self = this;

		$(document).on('submit', '.form-contact', function (e) {
			e.preventDefault();

			var $this = $(this);
			var $form = $this.closest('form');
            var data = $this.serializeJson();
            data['Indicatif'] = data['Indicatif'].trim();
            $.Topic('loader-show').publish('.page');

            $.resetErrors($form);

			self.model.post(data, $form);
		});

		$(document).on('change', '.form-contact [name="Service"]', function () {
			var $this = $(this);
			var $form = $this.closest('.form-contact');
			var redaction = $form.find('[name="Redaction"]');
            var secure = $form.find('[id="bloc-contact-secure"]');
			var publication = $form.find('[name="Publication"]');

			if (redaction.exists()) {
				if ($this.val() == 'Editorial') {
					redaction.removeClass('hidden');
				} else {
					redaction.addClass('hidden');
				}
				redaction.val('');
			}
			if (publication.exists()) {
				if ($this.val() == 'Subscription') {
					publication.removeClass('hidden');
				} else {
					publication.addClass('hidden');
				}
            }
            if (secure.exists()) {
                if ($this.val() == 'Editorial') {
                    secure.addClass('show')
                } else {
                    secure.removeClass('show');
                }
            } 
		});

        $(document).on('input propertychange paste', '.form-contact [name="Nom"], .form-contact [name="Prenom"], .form-contact [name="Email"], .form-contact [name="Indicatif"], .form-contact [name="NumeroTelephone"]', function (e) {
			var $this = $(this);
			var $parent = $this.parent();

			if ($this.hasClass('is-invalid')) {
				$this.removeClass('is-invalid');
                $parent.closest('.form-group').find('.form-text').remove();
			}
		});
	}

	Global.FormContactComponent = FormContactComponent;
}(jQuery, window));